import {
    Alert, Grid, Box, Button, Card, CardContent, CardHeader, Collapse,
    FormHelperText, IconButton, InputAdornment, styled, Switch, TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react'

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { es } from 'date-fns/locale';
import { NumberFormatMoney } from '../useForm';
import NumberFormat from 'react-number-format';
import { useNavigate } from 'react-router-dom';
import SelectEmails from '../SelectEmails';
import AutocompleteResponsable from '../AutocompleteResponsable';
import { Can } from "@casl/react";
import { Ability } from "@casl/ability";
import jwt_decode from "jwt-decode";
import format from 'format-number'

const CheckedSwitch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&:before, &:after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&:before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        '&:after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
}));

export default function ProyectoPlanForma(props) {

    const { isEditing, setIsEditing, handleChangeProyecto, setProyectoPlan, setCheckedInvestigacion,
        checkedInvestigacion, proyectoPlan, plan, datosIniciales, fase, planMontoDisponible } = props

    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const obtenerReglas = () => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }

    let reglas = decoded.rules
    if (!reglas)
        reglas = obtenerReglas()
    const ability = new Ability(reglas);


    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [montoExcedido, setMontoExcedido] = useState(false);
    const [severity, setSeverity] = useState('error')
    const porcentajePrioridad1 = Number(Number(1) - Number(process.env.REACT_APP_PRIORIDAD_DOS)).toFixed(2)
    const porcentajePrioridad2 = Number(process.env.REACT_APP_PRIORIDAD_DOS)
    const navigate = useNavigate()
    const handleChangeInvestigacion = (e) => {
        //console.log(e.target.checked)
        setCheckedInvestigacion(e.target.checked);
        proyectoPlan.tipo = e.target.checked ? 'investigacion' : 'gestion'
        //console.log(`proyecto plan ${checkedInvestigacion} ${JSON.stringify(proyectoPlan)}`)
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        proyectoPlan.idPlan = plan.idPlanPresupuestal
        if (!proyectoPlan.tipo) {
            proyectoPlan.tipo = checkedInvestigacion ? 'investigacion' : 'gestion'
        }
        const forma = document.getElementById('guardarProyectoPlan')
        proyectoPlan.responsable = forma['responsable'].value
        setLoading(true)
        //console.log(`Proyecto plan antes de guardar ${JSON.stringify(proyectoPlan)}`)

        if (!proyectoPlan.montoMaximo)
            proyectoPlan.montoMaximo = '0'
        if (!proyectoPlan.prioridad1)
            proyectoPlan.prioridad1 = '0'
        if (!proyectoPlan.prioridad2)
            proyectoPlan.prioridad2 = '0'
        if (isNaN(proyectoPlan.montoMaximo)) {
            const monto = proyectoPlan.montoMaximo.replace(/,/g, '')
            proyectoPlan.montoMaximo = monto
        }
        let res
        if (isEditing) {
            res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/${proyectoPlan.id}`, {
                method: "PUT",
                body: JSON.stringify(proyectoPlan),
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
            })
            if (proyectoPlan.tipo === 'investigacion') {
                const response = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectos/investigacion/${proyectoPlan.idProyectoInvestigacion}`, {
                    method: "PUT",
                    body: JSON.stringify(proyectoPlan),
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    },
                })
                if(response.status === 200)
                    setSeverity('success')
                else
                    setSeverity('error')
                const data = await response.json()
                setOpen(true)
                if (data.message)
                    setMensaje(mensaje + data.message)
            }
            else {
                const response = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectos/gestion/${proyectoPlan.idProyectoGestion}`, {
                    method: "PUT",
                    body: JSON.stringify(proyectoPlan),
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    },
                })
                const data = await response.json()
                if(response.status === 200)
                    setSeverity('success')
                else
                    setSeverity('error')
                setOpen(true)                
                if (data.message)
                    setMensaje(mensaje + data.message)
            }
        }
        else {
            res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/${sessionStorage.getItem('idEntidad')}`, {
                method: "POST",
                body: JSON.stringify(proyectoPlan),
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
            })
            if(res.status === 200)
                setSeverity('success')
            else
                setSeverity('error')
        }
        const data = await res.json()
        setOpen(true)
        if (data.message) {
            setMensaje(data.message)

        }
        else {
            setMensaje('El proyecto se ha guardado')
            navigate(0)
            const forma = document.getElementById('guardarProyectoPlan')
            if (forma)
                forma.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click()
        }
        setLoading(false)
        return
    }
    const verificarPrioridad = async (elemento, montoMaximoPrioridadN, prioridadN, N, elemento2, montoMaximoPrioridadM, M) => {
        const valor = elemento.value.replace(/,/g, '')
        const nombre = elemento.name

        const montoMaximo = isNaN(proyectoPlan.montoMaximo) ? proyectoPlan.montoMaximo.replace(/,/g, '') : proyectoPlan.montoMaximo

        setProyectoPlan({ ...proyectoPlan, [nombre]: valor, [prioridadN]: montoMaximo - valor })

        if (Number(valor) > Number(montoMaximo)) {
            setSeverity('error')
            setMensaje(`El monto de la Prioridad ${N} ${format({ prefix: '$' })(valor)} no debe superar al monto del proyecto ${format({ prefix: '$' })(montoMaximo)}`)
            setOpen(true)
            setMontoExcedido(true)
            elemento.style.color = 'red'
            return;
        }
        else {
            elemento.style.color = 'black'
            setMontoExcedido(false)
            setOpen(false)
        }
        //console.log(`valor ${valor} montoMaximoPrioridadN ${montoMaximoPrioridadN}`)
        if (Number(valor) > Number(montoMaximoPrioridadN)) {
            setSeverity('error')
            setMensaje(`Prioridad ${N} del proyecto ${format({ prefix: '$' })(valor)} no puede superar a Prioridad ${N} disponible del plan ${format({ prefix: '$' })(montoMaximoPrioridadN)}`)
            setOpen(true)
            setMontoExcedido(true)
            elemento.style.color = 'red'
            return;
        }
        else {
            elemento.style.color = 'black'
            setMontoExcedido(false)
            setOpen(false)
        }
        ////////////////////////////////////////////////
        const valor2 = montoMaximo - valor
        //console.log(`VALOR 2 = ${valor2} MONTO PRIORIDAD ${M} ${montoMaximoPrioridadM}`)

        if (Number(valor2) > Number(montoMaximo)) {
            setSeverity('error')
            setMensaje(`El monto de la Prioridad ${M} ${format({ prefix: '$' })(valor2)} no debe superar al monto del proyecto ${format({ prefix: '$' })(montoMaximo)}`)
            setOpen(true)
            setMontoExcedido(true)
            elemento2.style.color = 'red'
            return;
        }
        else {
            elemento2.style.color = 'black'
            setMontoExcedido(false)
            setOpen(false)
        }

        //console.log(`valor2 ${valor2} montoMaximoPrioridadM ${montoMaximoPrioridadM}`)
        if (Number(valor2) > Number(montoMaximoPrioridadM)) {
            setSeverity('error')
            setMensaje(`Prioridad ${M} del proyecto ${format({ prefix: '$' })(valor2)} no puede superar a Prioridad ${M} disponible del plan ${format({ prefix: '$' })(montoMaximoPrioridadM)}`)
            setOpen(true)
            setMontoExcedido(true)
            elemento2.style.color = 'red'
            return;
        }
        else {
            elemento2.style.color = 'black'
            setMontoExcedido(false)
            setOpen(false)
        }
    }

    return (
        <Grid item xs={12} style={{ marginTop: 15 }}>
            <Card>

                <CardHeader title={isEditing ? 'Editar Proyecto' : 'Agregar Nuevo Proyecto'} action={<Can I="manage" a="proyectoInvestigacion" ability={ability}><CheckedSwitch color="secondary" checked={checkedInvestigacion}
                    onChange={handleChangeInvestigacion} /><FormHelperText id='tipoProyecto' style={{ display: 'inline' }}>{checkedInvestigacion ? 'Investigación' : 'Gestión'}</FormHelperText></Can>}> </CardHeader>

                <CardContent>
                    <form id='guardarProyectoPlan' onSubmit={handleSubmit}>
                        <Grid container spacing={4}>
                            <Grid item>
                                <TextField label='Clave' name='clave' value={proyectoPlan.clave} onChange={handleChangeProyecto} focused variant='outlined' required={checkedInvestigacion} style={{ width: 300 }} />
                            </Grid>

                            <Grid item>
                                <TextField label='Proyecto' name='descripcion' value={proyectoPlan.descripcion} onChange={handleChangeProyecto} focused variant='outlined' required multiline style={{ width: 300 }}
                                    maxRows={4} />
                            </Grid>
                            {checkedInvestigacion ? (<>
                                <Grid item>
                                    <TextField label='Acuerdo' name='acuerdo' value={proyectoPlan.acuerdo} onChange={handleChangeProyecto} focused variant='outlined' required style={{ width: 300 }} />
                                </Grid>
                                <Grid item>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                        <DatePicker required label="Vigencia"
                                            value={`${proyectoPlan.vigencia}`}
                                            onChange={(newValue) => {
                                                setProyectoPlan({ ...proyectoPlan, "vigencia": newValue })
                                            }}
                                            renderInput={(params) => <TextField {...params} name="vigencia" id="vigencia" required focused variant='outlined' style={{ width: 300 }} />}
                                        />
                                    </LocalizationProvider>
                                </Grid></>) : (<></>)}
                            <Grid item>
                                {AutocompleteResponsable(proyectoPlan, isEditing)}
                            </Grid>
                            <Grid item>
                                {SelectEmails(proyectoPlan)}
                            </Grid>
                            {fase < 3 ? <>
                                <Grid item>
                                    <TextField style={{ width: 300 }} focused variant='outlined' onChange={(e) => {
                                        //console.log(`dentro de onchange ${e.target.value} monto previo ${proyectoPlan.montoPrevio} `)
                                        const valor = e.target.value
                                        const nombre = e.target.name
                                        const valorNumerico = valor.replace(/,/g, '')
                                        setProyectoPlan({ ...proyectoPlan, [nombre]: valor, 'prioridad1': Number(Number(valorNumerico) * Number(porcentajePrioridad1).toFixed(2)), 'prioridad2': Number(Number(valorNumerico) * Number(porcentajePrioridad2)).toFixed(2) })

                                        const montoMaximo = valor.replace(/,/g, '')
                                        if (Number(montoMaximo) > (Number(planMontoDisponible) + Number(proyectoPlan.montoPrevio ? proyectoPlan.montoPrevio : 0))) {
                                            //console.log(`entró al if proyecto ${montoMaximo}  plan ${planMontoDisponible}`)
                                            setSeverity('error')
                                            setMensaje(`El monto del proyecto ${format({ prefix: '$' })(montoMaximo)} no puede superar al monto disponible del plan ${format({ prefix: '$' })(Number(planMontoDisponible) + Number(proyectoPlan.montoPrevio ? proyectoPlan.montoPrevio : 0))}`)
                                            setOpen(true)
                                            setMontoExcedido(true)
                                            e.target.style.color = 'red'
                                            return;
                                        }
                                        else {
                                            e.target.style.color = 'black'
                                            setMontoExcedido(false)
                                            setOpen(false)
                                        }

                                        if ((Number(plan.prioridad1Disponible) + Number(proyectoPlan.prioridad1MontoPrevio ? proyectoPlan.prioridad1MontoPrevio : 0)) < Number(valorNumerico * porcentajePrioridad1)) {
                                            setSeverity('error')
                                            setMensaje(`El monto de la prioridad 1 ${format({ prefix: '$' })(valorNumerico * porcentajePrioridad1)} no puede superar al monto disponible de la prioridad1 del plan ${format({ prefix: '$' })(Number(plan.prioridad1Disponible) + Number(proyectoPlan.prioridad1MontoPrevio ? proyectoPlan.prioridad1MontoPrevio : 0))}`)
                                            setOpen(true)
                                            setMontoExcedido(true)
                                            document.getElementById('prioridad1').style.color = 'red'
                                            return
                                        }
                                        else {
                                            setOpen(false)
                                            setMontoExcedido(false)
                                            document.getElementById('prioridad1').style.color = 'black'
                                        }
                                        if ((Number(plan.prioridad2Disponible) + Number(proyectoPlan.prioridad2MontoPrevio ? proyectoPlan.prioridad2MontoPrevio : 0)) < (valorNumerico * porcentajePrioridad2)) {
                                            setSeverity('error')
                                            setMensaje(`El monto de la prioridad 2 ${format({ prefix: '$' })(valorNumerico * porcentajePrioridad2)} no puede superar al monto disponible de la prioridad 2 del plan ${format({ prefix: '$' })(Number(plan.prioridad2Disponible) + Number(proyectoPlan.prioridad2MontoPrevio ? proyectoPlan.prioridad2MontoPrevio : 0))}`)
                                            setOpen(true)
                                            setMontoExcedido(true)
                                            document.getElementById('prioridad2').style.color = 'red'
                                            return
                                        }
                                        else {
                                            setOpen(false)
                                            setMontoExcedido(false)
                                            document.getElementById('prioridad2').style.color = 'black'
                                        }
                                        //console.log(`proyecto.montoMaximo ${montoMaximo} planMontoDisponible ${planMontoDisponible} proyecto.montoPrevio ${proyectoPlan.montoPrevio ? proyectoPlan.montoPrevio : 0}`)

                                    }} name='montoMaximo' id='montoMaximo' value={proyectoPlan.montoMaximo} label="Escriba el monto" InputProps={{
                                        inputComponent: NumberFormatMoney,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        ),
                                    }} />

                                </Grid>
                                <Grid item>
                                    <TextField style={{ width: 300 }} focused variant='outlined' onChange={async (e) => {
                                        const montoMaximoPrioridad1 = Number(plan.prioridad1Disponible) + Number(proyectoPlan.prioridad1MontoPrevio ? proyectoPlan.prioridad1MontoPrevio : 0)
                                        const montoMaximoPrioridad2 = Number(plan.prioridad2Disponible) + Number(proyectoPlan.prioridad2MontoPrevio ? proyectoPlan.prioridad2MontoPrevio : 0)

                                        await verificarPrioridad(e.target, montoMaximoPrioridad1, 'prioridad2', 1, document.getElementById('prioridad2'),
                                            montoMaximoPrioridad2, 2)


                                    }} id='prioridad1' name='prioridad1' value={proyectoPlan.prioridad1} label="Prioridad 1" InputProps={{
                                        inputComponent: NumberFormatMoney,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        ),
                                    }} /*disabled={fase>2}*/ />

                                </Grid>
                                <Grid item>
                                    <TextField style={{ width: 300 }} focused variant='outlined' onChange={async (e) => {
                                        const montoMaximoPrioridad1 = Number(plan.prioridad1Disponible) + Number(proyectoPlan.prioridad1MontoPrevio ? proyectoPlan.prioridad1MontoPrevio : 0)
                                        const montoMaximoPrioridad2 = Number(plan.prioridad2Disponible) + Number(proyectoPlan.prioridad2MontoPrevio ? proyectoPlan.prioridad2MontoPrevio : 0)
                                        //console.log(`(proyectoPlan.prioridad1) > (montoMaximo) ${Number(valor) > Number(montoMaximo) } valor=${valor} montoMaximo=${montoMaximo}` )                        
                                        await verificarPrioridad(e.target, montoMaximoPrioridad2, 'prioridad1', 2, document.getElementById('prioridad1'),
                                            montoMaximoPrioridad1, 1)
                                    }} id='prioridad2' name='prioridad2' value={proyectoPlan.prioridad2} label="Prioridad 2" InputProps={{
                                        inputComponent: NumberFormatMoney,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        ),
                                    }} /*disabled={fase>2}*/ />

                                </Grid></>
                                : <></>}
                            <Grid item>
                                <Button variant='contained' color='primary' type='submit' disabled={montoExcedido || loading}>
                                    Guardar
                                </Button>
                                {isEditing ?
                                    <Button variant='contained' color='primary' type='button' style={{ marginLeft: '20px' }} onClick={() => {
                                        setIsEditing(false);
                                        setProyectoPlan(datosIniciales);
                                        const forma = document.getElementById('guardarProyectoPlan')
                                        if (forma)
                                            forma.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click()
                                        setMontoExcedido(false)
                                        setOpen(false)
                                        document.getElementById('prioridad1').style.color = 'black'
                                        document.getElementById('prioridad2').style.color = 'black'
                                        document.getElementById('montoMaximo').style.color = 'black'

                                    }}>
                                        Cancelar
                                    </Button> : <></>}
                            </Grid>
                        </Grid>

                    </form>
                    <Box sx={{ width: '100%' }}>
                        <Collapse in={open}>
                            <Alert severity={severity}
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                            setOpen(false);
                                        }}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                                style={{ marginTop: 30 }}
                            >
                                {mensaje}
                                {mensaje === 'El monto no puede superar al monto disponible del plan ' ? <NumberFormat value={planMontoDisponible} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> : <></>}

                            </Alert>
                        </Collapse>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    )
}